import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Upload, Form, Input } from "antd";
import Resizer from "react-image-file-resizer";
import { useDispatch } from "react-redux";
// redux
import { uploadFile } from "../../../store/stripe/stripe.action";

const PaymentAdditionalDocumentFront = (props) => {
  // -------------------------- VAR --------------------------
  const form = Form.useFormInstance();
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [image, setPreview] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 8;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = (action) => {
    const file = action.file;
    setLoading(true);
    dispatch(
      uploadFile({ file }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          const id = response.data.id;
          form.setFieldValue("addDocFront", id);
          message.success("Update Image successfully!");
          Resizer.imageFileResizer(
            file,
            512,
            512,
            "jpg",
            96,
            0,
            (uri) => {
              setPreview(uri);
            },
            "base64"
          );
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onChange = (value) => {
    console.log({ value });
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  const renderImage = () => {
    return (
      // eslint-disable-next-line jsx-a11y/img-redundant-alt
      <img
        src={image}
        alt="image-preview"
        style={{
          width: "100%",
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Front</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Upload
        name="image"
        listType="picture-card"
        className="image-uploader"
        showUploadList={false}
        disabled={loading}
        beforeUpload={beforeUpload}
        customRequest={handleUpload}
        onChange={onChange}
      >
        {image ? renderImage() : renderButton()}
      </Upload>
      <Form.Item
        name="addDocFront"
        rules={[
          {
            required: false,
            message: "Please add utility bill front",
          },
        ]}
      >
        <Input hidden />
      </Form.Item>
    </>
  );
};

export default PaymentAdditionalDocumentFront;
